import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useSocialShareStore from 'src/stores/socialShareStore';
import useSystemOptionsStore from 'src/stores/systemOptionsStore';
import useTrackMapsStore from 'src/stores/trackMapsStore';
import SocialSharingPage from './SocialSharingPage';

const SocialSharingResolver = () => {
  const fetchSettings = useSocialShareStore(s => s.fetchSettings);
  const fetchTrackMaps = useTrackMapsStore(s => s.fetchTrackMaps);
  const fetchSystemOptions = useSystemOptionsStore(s => s.fetchSystemOptions);

  const loadDependencies = () =>
    Promise.all([
      fetchSettings().catch(() => undefined),
      fetchTrackMaps().catch(() => undefined),
      fetchSystemOptions().catch(() => undefined),
    ] as Array<Promise<void | AxiosResponse<unknown>>>);

  return <Resolver resolve={loadDependencies} successComponent={SocialSharingPage} />;
};

export default SocialSharingResolver;
